/**
 * @requires ./frc.js
 */

frc.modules.contactReview = function($module) {
    var self = this;
    self.data = {
        "$module": null,
        "enabled": true
    };

    if((typeof $module)=="string"){
        $module = $($module);
    }

    self.data.$module = $module;

    self.renderDropdownField = function(field, params){
        params = jQuery.extend({
            firstAsPlaceholder: true,
            nativeOnMobile: true,
            validateOnSubmit: true,
            forceRenderBelow: true,
            show: 6,
        }, params || {});
        field.Selecta(params);
    };
    self.init = function() {
        var submitted = $module.text().indexOf("Thank you for your message. It has been sent.") > -1;
        console.log('submitted',submitted);
        console.log('module',$module);
        if(submitted){
            $module.attr("data-submitted", "true");

        } else {
            $module.attr("data-submitted", "false");

            self.data.fields = {
                "name": $module.find(".cf_name"),
                "email": $module.find(".cf_email"),
                "phone": $module.find(".cf_phone"),
                "date": $module.find(".cf_date"),
                "location": $module.find(".cf_commentlocation"),
                "comments": $module.find(".cf_comments"),
                "submitButton": $module.find("input[type=\"submit\"]")
            };

            frc.api.brand.getLocations(function(response) {
                var locations = [];
                if (response.data.length) {
                    for (var i = 0; i < response.data.length; i++) {
                        locations.push(response.data[i].location.displayName);
                    }
                    locations.sort();

                    for (i = 0; i < locations.length; i++) {
                        self.data.fields.location.append('<option value="'+ locations[i] +'">'+ locations[i] +'</option>');
                    }
                    self.data.fields.location.on('selecta-init', function(e, o) {
                        o.$container.addClass('s-cf_commentlocation');
                    }).Selecta({ nativeOnMobile: true, firstAsPlaceholder: true });

                } else {
                    self.data.fields.location.parent().css('display', 'none');
                }
            });

            $module.find("[aria-required=\"true\"]").attr("required","required");
            self.data.fields.phone.attr("pattern", "^(([\\+]?[1]?[\\s]?(\\d{3}|\\(\\d{3}\\)))[\\-|\\s]?\\d{3}[\\-|\\s]?\\d{4})?$");

// Validation
            self.data.fields.name.on("invalid", function(e) {
                e.target.setCustomValidity("Please fill out this field");
            });
            self.data.fields.comments.on("invalid", function(e) {
                e.target.setCustomValidity("Please fill out this field");
            });
            self.data.fields.location.on("invalid", function(e){
                e.target.setCustomValidity("Please choose a location");
            });
            self.data.fields.phone.on("invalid", function(e){
                e.target.setCustomValidity("Please provide a phone number in xxx-xxx-xxxx format");
            });
            self.data.fields.email.on("invalid", function(e) {
                e.target.setCustomValidity("Please enter a valid email address");
            });

            // Clear field's error message if its value has changed
            for(i in self.data.fields){
                self.data.fields[i].on("change", function(e){
                    e.target.setCustomValidity("");
                });
            }

            $module.find("form").on("submit", function(e){
                self.data.fields.submitButton.attr('disabled', true);
                self.data.$module.addClass('busy');
                var $form = $(this);

                if (!frc.utilities.validateForm($form)) {
                    e.preventDefault();
                    self.data.$module.removeClass('busy');
                    self.data.fields.submitButton.attr('disabled', false);
                }
            });
        }

        $(window).trigger('contact-form-loaded', $('section.form'));
    }

    self.init();
    return self;
}
